import {ADDUSER,SYNCADDUSER,CLEARUSER,SYNCCLEARUSER,SYNCUSERSTATUS,USERSTATUS} from "../types";

export default {
  [SYNCADDUSER](context,payload){//废弃
    return new Promise((resolve, reject) => {
      context.commit(ADDUSER,payload);
      resolve('SUCCESS');
    })
  },
  [SYNCCLEARUSER](context,payload){
    return new Promise((resolve, reject) => {
      context.commit(CLEARUSER);
      resolve('SUCCESS');
    })
  },
  [SYNCUSERSTATUS](context,payload){
    return new Promise((resolve, reject) => {
      context.commit(USERSTATUS,payload);
      resolve('SUCCESS');
    })
  }
}